export function isVisibleRowIndex(rowIndex: number | undefined): rowIndex is number {
  return typeof rowIndex === "number" && rowIndex >= 0
}
